import React, { useEffect, useRef, useState } from "react";
import LayoutContainer from "../../components/Containers/LayoutContainer";
import PageHeader from "../../components/PageHeader/PageHeader";
import { ArrowLeft } from "react-bootstrap-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import CustomMultiSelectDropdown from "../../components/CustomMultiSelectDropdown/CustomMultiSelectDropdown";
import { type } from "os";
import CustomButton from "../../components/CustomButton/CustomButton";
import Select from "react-select";
import { customStyles, customSingleSelectStyles} from "../../utils/constants/CustomStyles.constants";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { useAppDispatch } from "../../store/storeRequests";
import { hideToast, showToast } from "../../store/Toast/toast.slice";


const Add_Post: React.FunctionComponent = () => {
  const navigate = useNavigate();
  const [groupInfo, setGroupInfo] = useState<any>({ group_ids: [] }) 
  const [initialState, setInitialState] = useState<any>({ group_ids: [] }) 
  const [groupError, setGroupError] = useState("")
  const [group, setGroup] = useState<any>([])
  const [selectedValue, setSelectedValue] = useState(null)
  // const location = useLocation()
  const cmpMounted = useRef(false)
  const dispatch = useAppDispatch();


  useEffect(() => {
    if (cmpMounted.current === true) return;
    cmpMounted.current = true;

      fetchGroupData()
 
  }, []);

  const handleBackToGroup = () => {
    navigate("/culturalPost");
  };
  const buttons = [
    {
      label: "Back To Main List",
      theme: "danger",
      icon: <ArrowLeft />,
      onClick: handleBackToGroup,
    },
  ];

  const handleSubmit = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault()
//     console.log("Group Inof",groupInfo)

//     console.log("Initial State",JSON.stringify(initialState))
// console.log("Later State",JSON.stringify(groupInfo))

    if (JSON.stringify(groupInfo) === JSON.stringify(initialState)) {
      dispatch(showToast(`No changes done.`));
      setTimeout(() => dispatch(hideToast()), 3000);
      return;
    }

    try {
      if(!groupInfo.group_ids || groupInfo.group_ids.length === 0 ){
        setGroupError("Group field is required")
        return
      }
      setGroupError("")
      const response = await postDetails(APIList.Add_group_cultural_club, groupInfo)
     console.log(response)

     if(response.statusCode === 200){
      dispatch(showToast(`Groups updated successfully.`));
      setTimeout(() => dispatch(hideToast()), 3000);
       setGroupInfo({
         group_ids: [],
       })
       navigate("/culturalPost")
     } else {
      dispatch(showToast(`Unable to update groups.`));
      setTimeout(() => dispatch(hideToast()), 3000);
     }
    } catch (error) {
      console.log("Some error occurred while adding groups", error)
      dispatch(showToast(`Some error occurred while adding groups.`));
      setTimeout(() => dispatch(hideToast()), 3000);
    }
  };

  const fetchGroupData = async ()=>{
    try {
      dispatch(showLoader("Loading data..."));
      const response = await postDetails(APIList.GET_ALL_GROUP, { })
      const activeGroups = response.data.filter((item: any) => item.status === 1)
      // console.log("Active Groups",activeGroups)
      const culturalgroups = await postDetails(APIList.GET_ALL_CULTURAL_GROUP, { })
      // console.log("existing groups", culturalgroups)
      if(Array.isArray(culturalgroups.data) && culturalgroups.data.length !== 0)
        {
          const existingGroups = culturalgroups.data.map((item:any)=> ({
            value: item.groupId,
            label: item.group_name
          }))
          setSelectedValue(existingGroups)
          const group_ids = culturalgroups.data.map((item: any) => item.groupId);
          setGroupInfo({group_ids});
          setInitialState({group_ids});
        }
      setGroup(activeGroups)
    } catch (error) {
      console.log("Error fetching groups", error)
      dispatch(showToast(`Some error occurred while fetching groups`));
      setTimeout(() => dispatch(hideToast()), 3000);
    } finally{
      dispatch(hideLoader());
    }
}

const handleSelectChange = (selectedOptions: any) => {
  // console.log("Selected groups",selectedOptions)
  setSelectedValue(selectedOptions)
  const group_ids = selectedOptions.map((item:any)=> item.value)
  setGroupInfo({group_ids})
};

const options = group.map((item:any) => ({ value: item.id, label: item.name }));

  return (
    <LayoutContainer title="AddPostGroup">
      <div className=" page-header d-flex align-items-center justify-content-left dashboard-container h-100 mb-4">
        <h2>
          <i className=" page-header-icon fa fa fa-home"></i>
          Add Post Group
        </h2>
      <PageHeader buttons={buttons} />
      </div>
      <div className="mx-4 font-12">
        <form onSubmit={handleSubmit}>
            <div className="mb-4" style={{
              minHeight: "60px"
            }}>
              <label htmlFor="groups">Select Group <span className="text-danger">*</span></label>
              <Select
                isMulti
                styles={customStyles}
                closeMenuOnSelect={false}
                name="groups"
                id="groups"
                options={options}
                onChange={handleSelectChange}
                placeholder="Select Groups"
                value={selectedValue}
              />
              { groupError && <p className="error-text font-12 mt-2">{groupError}</p>}
            </div>
            <div>
            <CustomButton type="submit" size="md" theme="red">
            Submit
            </CustomButton>
          </div>
        </form>
      </div>
    </LayoutContainer>
  );
};

export default Add_Post;
